import { useState, FormEvent } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { apiClient } from '../services/api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { login } = useAuth();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    try {
      const response = await apiClient.login({ email, password });

      if (response.success) {
        const { user, accessToken, refreshToken } = response.data;
        login(user, accessToken, refreshToken);
        // Navigation will be handled by the route protection in App.tsx
      } else {
        setError(response.message || 'Falha no login');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Ocorreu um erro durante o login');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-1 px-4">
      <div className="w-full max-w-md">
        <div className="bg-bg-2 border border-bg-3 rounded-lg shadow-lg p-8">
          <div className="text-center mb-8">
            {/* Logo GeniAI */}
            <div className="flex justify-center mb-6">
              <img
                src="/geniAI1.webp"
                alt="GeniAI Logo"
                className="h-16 w-auto"
              />
            </div>
            <h1 className="text-3xl font-bold text-text-1 mb-2">
              Bem-vindo
            </h1>
            <p className="text-text-2">
              Faça login para continuar
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="bg-danger/10 border border-danger rounded-md p-3">
                <p className="text-danger text-sm">{error}</p>
              </div>
            )}

            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-text-1 mb-2"
              >
                Email
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                className="w-full px-4 py-2 bg-bg-1 border border-bg-3 rounded-md text-text-1 placeholder:text-text-3 focus:outline-none focus:ring-2 focus:ring-accent-1 focus:border-transparent transition-all"
                placeholder="seu@email.com"
                disabled={isLoading}
              />
            </div>

            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-text-1 mb-2"
              >
                Senha
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                className="w-full px-4 py-2 bg-bg-1 border border-bg-3 rounded-md text-text-1 placeholder:text-text-3 focus:outline-none focus:ring-2 focus:ring-accent-1 focus:border-transparent transition-all"
                placeholder="••••••••"
                disabled={isLoading}
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-accent-1 hover:bg-accent-2 text-white font-medium py-2.5 px-4 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-accent-1 focus:ring-offset-2 focus:ring-offset-bg-2"
            >
              {isLoading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-text-3 text-sm">
              Esqueceu sua senha?{' '}
              <a
                href="#"
                className="text-accent-1 hover:text-accent-2 font-medium transition-colors"
              >
                Recuperar
              </a>
            </p>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-text-3 text-sm">
            © 2025 GenIAI. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </div>
  );
}
